import React from 'react';
import { connect } from "react-redux";
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';

import { v4 as uuid } from 'uuid';

import GoogleLocationView from 'views/modals/GoogleLocationView';
import Company from "api/Company";

import {
	SHOW_MODAL_PRODUCT_LOCATION,
  HIDE_MODAL,
} from "actions/types";

class GoogleLocation extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {modalShow: false}
		
	}

	hide = () => {
		const {dispatch} = this.props;
		dispatch({type: HIDE_MODAL});
	}	
	
 MyVerticallyCenteredModal() {
	const {modalShow} = this.state;
	const {modalview} = this.props;
	const {header} = modalview;
	let viewHTml = null;
	if(modalview.show) {
		
		
		viewHTml = <GoogleLocationView {...this.props} onHideEvent={this.hide} />;
	}
  return (
    <Modal
      show={modalview && modalview.show}
		onHide={() => this.hide()}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
     {viewHTml}
    </Modal>
  );
}
	
	render() {
		const {modalview} = this.props;

		return (
			modalview && modalview.type == SHOW_MODAL_PRODUCT_LOCATION && modalview.show == true && 
			this.MyVerticallyCenteredModal()
		)
	}
}

function mapStateToProps(state) {
  const { modalview, auth } = state;
const { user } = auth;
  return {
    modalview,
	user
  };
}

export default connect(mapStateToProps)(GoogleLocation);